import { SecurityGuard } from "@duosoftbg/nacid-components";
import ServiceConfigWrapperPage from "../views/pages/ServiceConfigWrapperPage";
import { seVerLetterServiceConfig } from "../config/servicesConfig";
import React from "react";
import ServiceInfoPage from "../views/pages/ServiceInfoPage";
import SEVerLetterNewPage from "../views/pages/secondaryEducation/SEVerLetterNewPage";

export const seVerLetterRoutes = [
  {
    path: "/se-verification-letter",
    element: (
      <SecurityGuard doCheck={false}>
        <ServiceConfigWrapperPage serviceConfig={seVerLetterServiceConfig} wrappedPage={<ServiceInfoPage />} />
      </SecurityGuard>
    ),
  },
  {
    path: "/se-verification-letter/new",
    element: (
      <SecurityGuard loginOnUnauthorized={true}>
        <ServiceConfigWrapperPage serviceConfig={seVerLetterServiceConfig} wrappedPage={<SEVerLetterNewPage />} />
      </SecurityGuard>
    ),
  },
];
